import FormField from './FormField';

/**
 * Wraps the supplied form control component in a FormField.
 * @param {Object} Component Vue component options.
 * @returns A higher-order component consisting of the supplied
 *  component options wrapped in a FormField.
 */
export default function makeFormField(Component) {
  return {
    functional: true,
    render(h, context) {
      return h(
        FormField,
        {
          ...context.data,
          scopedSlots: {
            default: ({ attrs, listeners, classes }) => h(
              Component,
              { attrs, on: listeners, class: classes }
            )
          }
        },
      );
    }
  };
}
